import { FunctionComponent } from 'react';
import { SearchFieldSuggestionItemRowProps } from './SearchFieldSuggestionItemRowProps';

export const SearchFieldSuggestionItemRow: FunctionComponent<SearchFieldSuggestionItemRowProps> = ({
  item,
  onSelection
}) => {
  return (
    <button
      className="px-3 py-2 v-stack hover:text-white hover:bg-tint hover:bg-opacity-80 active:bg-opacity-100"
      key={item.id}
      onClick={onSelection}
    >
      {item.item}
    </button>
  );
};
